"use strict";Object.defineProperty(exports,"__esModule",{value:!0});const e=require("./css-color"),r=require("./css-linear-gradient");exports.fillToBackgroundCss=(o=>{switch(o.type){case"Color":return e.colorToCss(o.color);case"LinearGradient":return r.linearGradientToCss(o.linearGradient);default:throw Error(`Unsupported fill type: ${o.type}`)}});
//# sourceMappingURL=/@diez/web-sdk-common/lib/css-fill.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@diez/web-sdk-common/lib/css-fill.js
// module id = 414
// module chunks = 168707334958949